/**
 * Default map configuration values.
 * Madhya Pradesh centroid used as the default view.
 */
export const MAP_DEFAULTS = {
  // India geographic center
  center:          [20.5937, 78.9629],
  zoom:            5,
  minZoom:         4,
  maxZoom:         18,

  // fitBounds padding [top+bottom, left+right] in px
  fitPadding:      [50, 50],

  // Single marker zoom level
  singleMarkerZoom: 13,

  // Chunked loading for large marker sets
  chunkSize:       100,
  chunkDelay:      50,     // ms between chunks (0 = requestAnimationFrame only)

  // Debounce delays (ms)
  searchDebounce:  300,
  clusterDebounce: 250,

  // MarkerClusterGroup
  clusterRadius:   60,
  clusterMaxZoom:  16,     // disable clustering above this zoom

  // Default map height (px) — overridable via BaseLeafletMap :height prop
  mapHeight:       650,
};
